import { Link } from "react-router-dom";
import { Logo } from "@/components/Layout";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/", label: "Site", testId: "shell-nav-site" },
  { to: "/nossa-historia", label: "Nossa História", testId: "shell-nav-historia" },
  { to: "/links-do-dia-a-dia", label: "Links do Dia a Dia", testId: "shell-nav-links" },
];

export function PublicPageShell({ children, testId }) {
  return (
    <div className="flex min-h-screen flex-col bg-white" data-testid={testId}>
      <header className="sticky top-0 z-40 border-b border-zinc-800 bg-[#0A0A0A]/95 backdrop-blur-md" data-testid={`${testId}-header`}>
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Link to="/" aria-label="Instituto Musical Jacaré">
            <Logo dark />
          </Link>
          <nav className="hidden items-center gap-6 sm:flex">
            {NAV.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm font-medium text-zinc-300 transition-colors hover:text-primary"
                data-testid={l.testId}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <Button
            asChild
            variant="outline"
            size="sm"
            className="border-zinc-700 bg-transparent font-semibold text-white transition-colors hover:bg-zinc-800 hover:text-white"
            data-testid="shell-login-button"
          >
            <Link to="/acesso">Entrar</Link>
          </Button>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-zinc-800 bg-[#0A0A0A] px-4 py-6 text-center text-xs text-zinc-500">
        © 2026 Instituto Musical Jacaré — IMJ · Rua Luiz Nunes, 36 — Bairro Jacaré, Cabreúva/SP
      </footer>
    </div>
  );
}
